var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 125 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_139_4912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.282 0H6.84931C3.0295 0 0 2.99657 0 6.77486V33.3531C0 37.1314 3.16122 40.128 6.84931 40.128H47.0232V35.0469C47.0232 26.9691 53.6091 20.4549 61.7756 20.4549C65.7271 20.4549 69.4152 22.0183 72.1812 24.7543C74.9473 27.4903 76.5279 31.1383 76.5279 35.0469V40.128H118.151C121.97 40.128 125 37.0011 125 33.3531V6.77486C125.132 3.12686 122.102 0 118.282 0Z",
    fill: "#00A90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.632 62.7941C98.1293 62.7941 95.8901 64.097 94.7047 66.0512V65.921C94.7047 62.1427 91.5434 59.0158 87.7236 59.0158C85.221 59.0158 82.9818 60.3187 81.7963 62.273V62.1427C81.7963 58.3644 78.6351 55.2375 74.8153 55.2375C72.3127 55.2375 70.0735 56.5404 68.888 58.4947V35.0432C68.888 33.2192 68.0977 31.3952 66.7805 30.0924C65.4634 28.7895 63.751 28.0078 61.7753 28.0078C57.9555 28.0078 54.7942 31.1347 54.7942 34.913V80.2524C54.7942 80.6432 54.5308 81.0341 54.1356 81.1644C53.7405 81.2947 53.3453 81.2947 53.0819 80.9038L45.9692 73.8684C43.5982 71.5232 39.7784 71.1324 37.0124 73.0867C35.3 74.129 34.2463 75.953 33.9829 77.9072C33.7194 79.8615 34.2463 81.8158 35.5635 83.3792L53.3453 104.616C58.3506 110.609 65.7268 113.996 73.6298 113.996H84.6941C90.8849 113.996 96.6804 111.651 101.027 107.352C105.374 103.052 107.745 97.3198 107.745 91.1964V69.569C107.613 65.921 104.452 62.7941 100.632 62.7941Z",
    fill: "#00A90B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_139_4912",
    x: 0,
    y: 0,
    width: 125.004,
    height: 118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_139_4912"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinger);
export default __webpack_public_path__ + "static/media/finger.9a87c641f3ca65ad85761dd349e09a2b.svg";
export { ForwardRef as ReactComponent };